export default {
  // 页面标题和导航
  pageTitle: '节点管理',
  businessTypeSelector: '选择业务类型：',
  businessNodeEditor: '业务节点编辑器',

  // 业务类型
  businessTypes: {
    sea: '海运订单',
    air: '空运订单',
    land: '陆运订单',
    rail: '铁路订单'
  },

  // 节点相关
  node: {
    name: '节点名称',
    description: '节点描述',
    icon: '节点图标',
    enabled: '启用状态',
    tasks: '任务',
    taskCount: '{count} 个任务',
    addNode: '添加节点',
    editNode: '编辑业务节点',
    insertNode: '插入业务节点',
    createNode: '新增业务节点',
    deleteNode: '删除节点',
    deleteConfirm: '确认删除节点',
    deleteMessage: '删除后不可恢复，确定要删除这个业务节点吗？',
    confirmDelete: '确定删除',
    startNode: '开始',
    startNodeDescription: '工作流起始节点'
  },

  // 表单相关
  form: {
    nodeNamePlaceholder: '请输入节点名称，如：报价确认',
    nodeNameRequired: '请输入节点名称',
    nodeDescriptionPlaceholder: '请输入节点描述（可选）',
    nodeIconLabel: '节点图标',
    uploadIcon: '上传图标',
    iconFormat: '支持 JPG、PNG、GIF 格式，文件大小不超过 2MB',
    enabledLabel: '启用状态'
  },

  // 任务管理
  tasks: {
    title: '任务配置',
    addTask: '添加任务',
    deleteTask: '删除任务',
    taskName: '任务名称',
    taskType: '任务性质',
    contactPersonType: '对接人类型',
    exclusiveContactPerson: '专属对接人',
    skippable: '是否可跳过',
    relatedPage: '关联页面（可选）',
    parentTask: '父任务（可选）',
    deadline: '截止时间（可选）',

    // 任务类型
    types: {
      external: '外部任务',
      internal: '内部任务'
    },

    // 对接人类型
    contactPersonTypes: {
      exclusive: '专属对接人',
      businessOwner: '业务负责人'
    },

    // 专属对接人选项
    exclusiveContactOptions: {
      sales: '专属销售',
      customer_service: '专属客服',
      operation: '专属操作',
      documentation: '专属单证',
      business: '专属商务',
      finance: '专属财务'
    },

    // 截止时间配置
    deadlineConfig: {
      baseEvent: '选择基准事件',
      direction: '选择方向',
      value: '数值',
      unit: '单位'
    },

    // 表单验证
    validation: {
      taskNamePlaceholder: '请输入任务名称',
      selectContactPersonType: '请选择对接人类型',
      selectExclusiveContactPerson: '请选择专属对接人',
      selectRelatedPage: '请选择关联页面',
      selectParentTask: '请选择父任务',
      selectBaseEvent: '选择基准事件',
      selectDirection: '选择方向',
      enterValue: '数值',
      selectUnit: '单位',
      exclusiveContactPersonRequired: '请选择专属对接人'
    },

    // 任务状态
    noTasks: '暂无任务，点击"添加任务"开始配置',
    taskIndex: '任务 {index}',
    autoGenerated: '自动带出'
  },

  // 工具栏操作
  toolbar: {
    addNode: '添加节点',
    resetLayout: '重置布局',
    saveSettings: '保存设置'
  },

  // 保存确认弹窗
  saveDialog: {
    title: '确认保存',
    message: '保存后业务节点将对所有新业务生效，确认保存？',
    confirm: '确认',
    cancel: '取消'
  },

  // 按钮文本
  buttons: {
    save: '保存',
    update: '更新',
    cancel: '取消',
    confirm: '确认',
    delete: '删除',
    edit: '编辑'
  },

  // 成功/错误消息
  messages: {
    configLoadSuccess: '{businessType}配置加载成功',
    configLoadFailed: '加载工作流配置失败',
    workflowNotInitialized: '当前业务类型尚未创建工作流，无法保存，请联系管理员配置。',
    configSaveSuccess: '配置保存成功',
    configSaveFailed: '配置保存失败',
    nodeUpdateSuccess: '节点更新成功',
    nodeAddSuccess: '节点添加成功',
    nodeInsertSuccess: '节点插入成功',
    iconUploadSuccess: '图标上传成功',
    iconUploadFailed: '图标上传失败',
    iconRemoved: '图标已移除',
    imageLoadError: '节点图标加载失败',
    formValidationFailed: '表单验证失败',

    // 文件上传相关
    fileInvalid: '文件对象无效',
    imageTypeError: '只能上传图片文件!',
    fileSizeError: '图片大小不能超过 2MB!',
    uploadError: '上传失败，未获取到文件ID',

    // 页面加载相关
    pageConfigLoadFailed: '获取页面配置失败',

    // 自动生成任务相关
    cannotModifyAutoGeneratedTaskParent: '自动生成的任务的父任务不能修改'
  },

  // 其他文本
  others: {
    currentBusinessType: '当前业务类型',
    workflowStartNode: '工作流起始节点',
    cannotEditStartNode: '开始节点不可编辑',
    cannotDeleteStartNode: '开始节点不可删除',
    savingConfig: '正在保存配置数据',
    loadingPageConfig: '正在加载页面配置'
  }
}
